export const LABELS = {
  CHOICES: {
    LEVE: 'Leve',
    LOGGI: 'Agência'
  },
  LABEL: 'Selecione o tipo da base'
};

export default { LABELS };
